import {Col, Row} from 'antd';
import React from 'react';

import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import LabelChart from '../../../../components/LabelChart';
import TotalChartList from '../../../../components/TotalChartList';
import {rowGutterNZM} from '../../../../constants/commonConstants';

const FinancialFuel: React.FC<{data: any[]}> = ({data}) => {
  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={4}>
          <LabelChart
            data={data}
            keyArray={[
              'vehicle maintenance cost',
              'leased vehicle',
              'non leased vehicle'
            ]}
            chartType="progressWithOutTotal"
            customLabel="TOTAL CONSUMPTION"
            showTotal={true}
            customTotalTitle="TOTAL COST"
            isCost={true}
          />
        </Col>
        <Col span={20}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={['fuel cost']}
            data={data}
            dataInMainData={true}
            showChartList={false}
            isCost={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default FinancialFuel;
